// extracted by mini-css-extract-plugin
module.exports = {"cell":"RoleTable_cell_2auVP","badge":"RoleTable_badge_uc9_Y"};